import { Box, type BoxProps, Typography, type TypographyProps } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

export const Root = styled(Box)<BoxProps>(({ theme }) => ({
  width: "100%",
  maxWidth: "100%",
  padding: "14px",
  borderRadius: theme.shape.borderRadius,
  backgroundColor:
    theme.palette.mode === "dark"
      ? alpha(theme.palette.common.white, 0.06)
      : theme.palette.secondary.main,
  overflowWrap: "anywhere",
  wordBreak: "break-word",
}));

export const Paragraph = styled(Typography)<TypographyProps>(({ theme }) => ({
  margin: 0,
  lineHeight: 1.7,
  color: theme.palette.text.secondary,
}));
